import React from 'react';
import withExperiment from './with-experiment';
import _ from 'lodash';

const forExperiment = (experimentName, ComponentExperimentTrue, ComponentExperimentFalse) => {
  const config = { [experimentName]: experimentName };
  return withExperiment(config)(props => {
    const isExperimentEnabled = props[experimentName];
    const Component = isExperimentEnabled ? ComponentExperimentTrue : ComponentExperimentFalse;
    const newProps = _.omit(props, [experimentName]);

    return Component ? <Component {...newProps}/> : null;
  });
};

export default forExperiment;



// WEBPACK FOOTER //
// ./app/hoc/for-experiment.js